import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-database-hosting',
  templateUrl: './database-hosting.component.html',
  styleUrls: ['./database-hosting.component.scss']
})
export class DatabaseHostingComponent implements OnInit {
  logoImg=`../../../assets/imgs/logo/se2in_logo.png`
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: 'DATABASE_HOSTING',
    titleIcon: ''
  };

  List: any[] = [
    {
      title: 'MARIA_DB',
      image: './assets/images/fancy-list/01.png',
      services: [{ title: 'HOSTED_IN_GERMANY_FEATURE_1' }, { title: 'HOSTED_IN_GERMANY_FEATURE_2' }],
      desc: 'MARIA_DB_EXPLANATION'
    },
    {
      title: 'CLUSER_ADVANTAGE',
      image: 'assets/images/fancy-list/02.png',
      services: [{ title: 'Advance Advisory Team' }, { title: 'Professional Services' }],
      desc: 'CLUSTER_EXPLANATION'
    },
    {
      title: 'DATA_SECURITY',
      image: 'assets/images/fancy-list/03.png',
      services: [{ title: 'Advance Advisory Team' }, { title: 'Professional Services' }],
      desc: 'DATA_SECURITY_EXPLANATION'
    },
    {
      title: 'BACKUP_SOFTWARE',
      image: 'assets/images/fancy-list/04.png',
      services: [{ title: 'Advance Advisory Team' }, { title: 'Professional Services' }],
      desc: 'BACKUP_SOFTWARE_EXPLANATION'
    },
    {
      title: 'JAVA_API',
      image: 'assets/images/fancy-list/05.png',
      services: [{ title: 'Advance Advisory Team' }, { title: 'Professional Services' }],
      desc: 'JAVA_API_EXPLANATION'
    },
    {
      title: 'HOSTED_IN_GERMANY',
      image: './assets/images/fancy-list/01.png',
      services: [{ title: 'HOSTED_IN_GERMANY_FEATURE_1' }, { title: 'HOSTED_IN_GERMANY_FEATURE_2' }],
      desc: 'HOSTED_IN_GERMANY_EXPLANATION'
    }
  ];


  ngOnInit(): void {
  }
}
